import { Well, type WellProps } from './well';

export type BainGenericContainerProps = WellProps;

export function BainGenericContainer(props: BainGenericContainerProps) {
  return <Well {...props} />;
}
